module.exports = __webpack_public_path__ + "static/media/image-video-13.de480bb6.png";